import { _IDeliveryStatus, _IStatusHistory } from '@data/types'

export const getStatusTime = (
  statusHistory: _IStatusHistory[] | null,
  status: _IDeliveryStatus | _IDeliveryStatus[]
) => {
  if (!statusHistory) return null

  const statusArray = Array.isArray(status) ? status : [status]

  for (const currentStatus of statusArray) {
    const currentHistoryStatus = statusHistory.find(
      (item: _IStatusHistory) => item.statusTo === currentStatus
    )

    if (currentHistoryStatus) {
      return currentHistoryStatus.updatedAt
    }
  }

  return null
}
